import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions, mapGetters } from 'vuex';
export default {
  data: function data() {
    return {
      isShowDELIVERY_NO: true,
      // 输入送货单号
      isShowVENDOR_CODE: true,
      // 输入供应商代码
      isShowVENDOR: true,
      // 输入供应商
      isShowSeach: true,
      // 查询
      isShowAdd: true,
      // 新增
      isShowExport: false,
      // 数据导出
      isShowBlack: false,
      // 返回
      isShowSave: false,
      // 保存
      isShowAddRow: false,
      // 新增明细
      isShowEditOrder: false,
      // 修改明细
      isShowAuditOrder: false,
      // 审核
      isShowUnAuditOrder: false,
      // 反审核
      isShowPrinter: false,
      // 打印
      isShowNext: true,
      // 上一张下一张
      isShowCancellation: false,
      // 作废
      isShowCancel: false,
      // 取消
      isShowSelectOrder: false,
      // 选择送货单
      isCreatePartBarcode: false,
      // 生成标签
      isShowExportPartDetail: false,
      // 明细导出
      isShowExportPartBarcode: false,
      // 条码导出
      VENDOR_CODE: null,
      // 供应商
      selectLoading: false,
      vendorOptions: [],
      DELIVERY_NO: null,
      // 送货单号
      OrderList: [],
      // 单据列表
      currentIndex: null,
      nextIndex: null,
      orderStatus: null,
      // 单据状态
      orderInfo: {} // 单据内容

    };
  },
  mounted: function mounted() {},
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/DnbarcodeHandmadeOutBox', ['setOrderStatu'])), {}, {
    // 设置状态
    setStatus: function setStatus(status) {
      // console.log(status);
      this.controlBtnShow(status);
    },
    // 条码明细导出
    handleExportPartBarcode: function handleExportPartBarcode() {
      this.$emit('onHandleExportPartBarcode');
    },
    // 物料明细导出
    handleExportPartDetail: function handleExportPartDetail() {
      this.$emit('onHandleExportPartDetail');
    },
    // 点击取消
    handleCancelBtn: function handleCancelBtn() {
      this.$emit('onHandleCancelBtn');
    },
    // 点击修改
    handleEdit: function handleEdit() {
      this.$emit('handleEdit');
    },
    // 组合打印内箱标签
    handlePrintParBarcodeGroup: function handlePrintParBarcodeGroup() {
      // this.Bus.emit('onPrintOuterBoxLabel')
      this.$emit('onHandlePrintParBarcodeGroup');
    },
    // 点击生成标签
    handleCreateOutBoxBarcodeData: function handleCreateOutBoxBarcodeData() {
      this.$emit('handleCreateOutBoxBarcodeData');
    },
    // 点击选择物料
    handleSelectOrder: function handleSelectOrder() {
      this.$emit('onSelectMaterial');
    },
    // 点击上一张
    handleUpNextOrder: function handleUpNextOrder() {
      // console.log(this.currentIndex);
      // if(this.currentIndex === 0){
      //     this.$message.warning('没有上一张订单了')
      //     return
      // }
      // this.currentIndex = this.currentIndex -= 1
      // let data = this.OrderList[this.currentIndex]
      // this.controlBtnShow(data.STATUS)
      // this.Bus.emit('nextOrder',data)
      this.$emit('getBackOrder');
    },
    // 点击下一张
    handleDownNextOrder: function handleDownNextOrder() {
      // console.log(this.currentIndex);
      // if((this.currentIndex + 1) > this.OrderList.length - 1){
      //     this.$message.warning('没有下一张订单了')
      //     return
      // }
      // this.currentIndex = this.currentIndex += 1
      // let data = this.OrderList[this.currentIndex]
      // this.controlBtnShow(data.STATUS)
      // this.Bus.emit('nextOrder',data)
      this.$emit('nextOrder');
    },
    // 点击保存
    handleSave: function handleSave() {
      this.$emit('onSave');
    },
    // 点击返回
    handleBlackBtn: function handleBlackBtn() {
      var _this = this;

      if (this.$DnbarcodeHandmadeState === 'editOrder') {
        this.$confirm('返回不会保存已修改的明细, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this.setOrderStatu('orderShow');
        }).catch(function () {
          _this.$message.warning('已取消');
        });
      } else {
        this.$emit('handleBlackBtn');
      }
    },
    // 控制按钮显示
    controlBtnShow: function controlBtnShow(status) {
      if (status === 1) {
        // 未确认
        this.isShowAuditOrder = true;
        this.isShowUnAuditOrder = false;
        this.isShowEditOrder = true;
        this.isShowPrinter = true;
        this.isShowCancellation = true;
      } else if (status === 2) {
        // 已审核
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = true;
        this.isShowPrinter = true;
        this.isShowCancellation = false;
      } else if (status === 3) {
        // 作废
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = false;
        this.isShowPrinter = false;
        this.isShowCancellation = false;
      } else if (status === 4) {
        // 在途
        this.isShowEditOrder = false;
        this.isShowUnAuditOrder = true;
        this.isShowPrinter = true;
        this.isShowAuditOrder = false;
        this.isShowCancellation = false;
      } else if (status === 5) {
        // 收货
        this.isShowPrinter = true;
        this.isShowUnAuditOrder = false;
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowCancellation = false;
      } else if (status === 9) {
        // 全关闭
        this.isShowUnAuditOrder = false;
        this.isShowAuditOrder = false;
        this.isShowEditOrder = false;
        this.isShowPrinter = false;
        this.isShowCancellation = false;
      }
    }
  }),
  watch: {
    $DnbarcodeHandmadeOutBoxState: {
      handler: function handler(nawValue) {
        // console.log('单据操作状态==>',nawValue);
        if (nawValue === 'listShow') {
          // 订单列表
          this.isShowDELIVERY_NO = true;
          this.isShowVENDOR_CODE = true;
          this.isShowVENDOR = true;
          this.isShowSeach = true;
          this.isShowAdd = false;
          this.isShowExport = true;
          this.isShowBlack = false;
          this.isShowSave = false;
          this.isShowAddRow = false;
          this.isShowNext = false;
          this.isShowCancel = false;
          this.isShowSelectOrder = false;
          this.isShowPrinter = false;
          this.isShowEditOrder = false;
          this.isShowExportPartDetail = false;
          this.isShowExportPartBarcode = false;
        } else if (nawValue === 'addOrder') {
          // 新增订单
          this.isShowSeach = false;
          this.isShowBlack = true;
          this.isShowSave = true;
          this.isShowSelectOrder = true;
          this.isCreatePartBarcode = false;
          this.isShowPrinter = false;
          this.isShowEditOrder = false;
          this.isShowCancel = false;
          this.isShowExportPartDetail = false;
          this.isShowExportPartBarcode = false;
          this.isShowNext = false;
        } else if (nawValue === 'orderShow') {
          // 订单明细
          this.isShowSeach = false;
          this.isShowBlack = true;
          this.isShowSave = false;
          this.isShowSelectOrder = false;
          this.isCreatePartBarcode = true;
          this.isShowPrinter = true;
          this.isShowEditOrder = true;
          this.isShowCancel = false;
          this.isShowExportPartDetail = true;
          this.isShowExportPartBarcode = true;
          this.isShowNext = true;
        } else if (nawValue === 'editOrder') {
          this.isShowBlack = false;
          this.isShowSelectOrder = true;
          this.isShowSave = true;
          this.isShowEditOrder = false;
          this.isShowPrinter = false;
          this.isShowCancel = true;
          this.isShowExportPartDetail = false;
          this.isShowExportPartBarcode = false;
          this.isShowNext = false;
        }
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$DnbarcodeHandmadeOutBoxState']))
};